import React, { forwardRef } from 'react';

export const TextAreaInputField = forwardRef(
  (
    {
      rows = 4,
      error,
      label,
      placeholder = 'Type here',
      extraClasses = 'resize--none',
      disabled = false,
      maxLength = 200,
      ...rest
    },
    ref,
  ) => {
    const text = error || label || '';

    return (
      <div className="w--full d--flex flex--column">
        {text && (
          <label
            className={`label--control font--sm font--500 m-b--sm  ${
              error ? 'text--danger' : 'text--black'
            }`}
          >
            {text}
          </label>
        )}
        <textarea
          {...rest}
          ref={ref}
          className={`form--control w--full h-min--36  radius--sm p--md  ${extraClasses} ${error ? 'border-full--danger' : 'border-full--black-200'}`}
          rows={rows}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
        ></textarea>
      </div>
    );
  },
);
